import { Config } from "Config";

// Redux Action Types
const SET_FIRST_CHAT = "boilerplate/ChatBot/SET_FIRST_CHAT";
const SET_RETRIEVAL_MODE = "boilerplate/ChatBot/SET_RETRIEVAL_MODE";
const SET_CHAT_LIST = "boilerplate/ChatBot/SET_CHAT_LIST";
const SET_LOADER_STATUS = "boilerplate/ChatBot/SET_LOADER_STATUS";
const SET_BATCH_ID = "boilerplate/ChatBot/SET_BATCH_ID";
const SET_CHAT_LIST_NEXT_URL = "boilerplate/ChatBot/SET_CHAT_LIST_NEXT_URL";
const SET_CHAT_LIST_HAS_MORE = "boilerplate/ChatBot/SET_CHAT_LIST_HAS_MORE";
const SET_SEARCH = "boilerplate/ChatBot/SET_SEARCH";
const SET_THINKING_MODE = "boilerplate/ChatBot/SET_THINKING_MODE";

const URL_CHATS = `${Config.url}api/v1/gttaxpro/chats/`;
const URL_OPEN_CHATS = `${Config.url}api/v1/gttaxpro/open-chats/`;
const URL_CHAT_HISTORIES = `${Config.url}api/v1/gttaxpro/chat-history/`;
const URL_CHAT_MESSAGES = `${Config.url}api/v1/gttaxpro/chats/`; // GET chats/{id}/ for messages
const URL_UPLOAD = `${Config.url}api/v1/gttaxpro/upload-files/`;
const URL_VECTORISE = `${Config.url}api/v1/gttaxpro/vectorise/`;
const GET_CHAT_HISTORY = `${Config.url}api/v1/gttaxpro/chat-history/?page=1&page_size=10`;

const MODEL_OPTIONS = [
  { value: "auto", label: "Auto" },
  { value: "hybrid", label: "Hybrid" },
  { value: "user-uploaded", label: "User Uploaded" },
  { value: "knowledge-base", label: "Knowledge Base" },
];

const ACCEPTED_FILE_TYPES =
  ".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";

const ALLOWED_EXTENSIONS = ["pdf", "doc", "docx"];

const MAX_FILES = 5;
const MAX_TOTAL_SIZE_MB = 5;
const MAX_TOTAL_SIZE_BYTES = MAX_TOTAL_SIZE_MB * 1024 * 1024;

const STATUS_MAP = {
  // New RAG pipeline statuses
  plan_sections: "Planning response...",
  research_llm_call: "Researching...",
  research_tool_node: "Analyzing sources...",
  write_final_answer: "Writing response...",
  // SQL-based statuses (legacy)
  parse_question: "Looking for Relevant Tables & their Columns...",
  get_unique_nouns: "Generating SQL Query...",
  execute_sql: "Executing SQL Query...",
};

const ASSIST_OPTIONS = [
  {
    value: "instant",
    title: "Instant",
    subtitle: "For everyday chats",
  },
  {
    value: "thinking",
    title: "Thinking",
    subtitle: "For complex questions",
  },
];

export {
  MODEL_OPTIONS,
  ACCEPTED_FILE_TYPES,
  SET_FIRST_CHAT,
  SET_RETRIEVAL_MODE,
  SET_CHAT_LIST,
  SET_LOADER_STATUS,
  SET_BATCH_ID,
  SET_CHAT_LIST_NEXT_URL,
  SET_CHAT_LIST_HAS_MORE,
  SET_SEARCH,
  SET_THINKING_MODE,
  URL_UPLOAD,
  URL_CHATS,
  URL_OPEN_CHATS,
  URL_CHAT_HISTORIES,
  URL_CHAT_MESSAGES,
  STATUS_MAP,
  ALLOWED_EXTENSIONS,
  MAX_FILES,
  MAX_TOTAL_SIZE_MB,
  MAX_TOTAL_SIZE_BYTES,
  URL_VECTORISE,
  GET_CHAT_HISTORY,
  ASSIST_OPTIONS
};
